module.exports = __webpack_public_path__ + "img/pure-hits-retro.6d0e6372.png";